import type { StreamTraceAnalyzeState, UHStreamMessage } from './UHStreamMessage';

export const isUHTraceAnalyzingState = (
	message: UHStreamMessage,
): message is StreamTraceAnalyzeState =>
	message.type === 'TRACE' && message.message.message_template === 'ANALYSING_STATE';
